module.exports = __webpack_public_path__ + "img/timg.8bbe081e.gif";